import { Controller } from '@hotwired/stimulus';
import TomSelect from 'tom-select';

export default class extends Controller {

    connect(): void {

        const select = this.element as HTMLSelectElement;

        if ((select as any).tomselect) {
            return;
        }

        new TomSelect(select, {
            create: false,
            allowEmptyOption: true,
            dropdownParent: 'body',
            // Sin este plugin, un <select multiple> (p.ej. "Día de cobro") no muestra ninguna
            // "×" visible para sacar un valor ya elegido — hay que reabrir el desplegable y
            // hacer clic de nuevo sobre el día para destildarlo, lo cual no es obvio. No afecta
            // a los selects simples (no-multiple), donde el plugin no tiene efecto visible.
            plugins: ['remove_button'],
            onDropdownOpen: function(dropdown: HTMLElement) {
                dropdown.style.zIndex = '9999';
            },
            onChange: function() {
                // TomSelect's own 'change' is an internal pub/sub event, not a real DOM
                // event — plain addEventListener('change', ...) listeners elsewhere in the
                // app (delegated on document/containers) never see it otherwise.
                select.dispatchEvent(new Event('change', { bubbles: true }));
            },
        });
    }

    disconnect(): void {

        const ts = (this.element as any).tomselect;

        if (ts) {
            ts.destroy();
        }
    }
}
